import { Box, styled } from '@mui/material';
import trainingStatus from '../../constants/trainingStatus.json';

const getTrainingStatus = (type) => {
    console.log('trainingStatus', trainingStatus);
  const match = trainingStatus.find(status => status.value === type);
  console.log('getTrainingStatus', type, match);
  return match?.color || '#7180a0'; // fallback default color
}

const TrainingStatusBox = styled(Box)(({ type }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '4px 12px',
  borderRadius: '12px',
  color: 'white',
  backgroundColor: getTrainingStatus(type),
  fontWeight: 'bold',
  textAlign: 'center',
  minWidth: 0,
  whiteSpace: 'nowrap',
}));

export default TrainingStatusBox;

